type CustomersToolbarProps = Record<string, never>;

export function CustomersToolbar(_props: CustomersToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ລາຍການລູກຄ້າ</h2>
          <p className="text-muted-foreground">ເບິ່ງລາຍການລູກຄ້າ ແລະ ລະດັບສະມາຊິກ</p>
        </div>
      </div>
    </div>
  );
}
